// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Fit adjustment fields to the form column, including beside the preview. */
.debit-editor-form:has(.debit-adjustment-lines) {
  width: 100%;
}

.debit-adjustment-lines {
  container: debit-adjustment-lines / inline-size;
}

.debit-page .debit-adjustment-lines .debit-lines-table {
  overflow: visible;
}

.debit-adjustment-lines .debit-line-head,
.debit-adjustment-lines .debit-line-row {
  grid-template-columns: minmax(0, 1fr) 72px 120px 120px 64px;
}

.debit-adjustment-lines .debit-line-head > span {
  height: auto;
  min-height: 32px;
  text-align: left;
  overflow-wrap: anywhere;
}

.debit-adjustment-lines .debit-line-head > span:last-child {
  padding-inline: 0;
  white-space: nowrap;
  overflow-wrap: normal;
}

.debit-adjustment-lines .debit-line-row,
.debit-adjustment-lines .debit-line-row > label,
.debit-adjustment-lines .debit-description,
.debit-adjustment-lines .debit-line-total {
  height: auto;
  min-height: 64px;
}

.debit-adjustment-lines .debit-line-row:last-child {
  border-bottom-left-radius: var(--radius-md, 10px);
  border-bottom-right-radius: var(--radius-md, 10px);
}

.debit-page .debit-adjustment-lines .debit-line-row input {
  height: var(--control-height-md, 40px);
}

.debit-adjustment-lines .debit-description .sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
}

.debit-page .debit-adjustment-lines .debit-line-total strong {
  display: block;
  height: auto;
  min-height: var(--control-height-md, 40px);
  max-width: 100%;
  padding-block: 10px;
  overflow: visible;
  color: var(--text-primary);
  font-size: var(--font-size-money-md, 15px);
  text-align: right;
  white-space: normal;
  overflow-wrap: anywhere;
}

@container debit-adjustment-lines (max-width: 700px) {
  .debit-adjustment-lines .debit-line-head {
    display: none;
  }

  .debit-page .debit-adjustment-lines .debit-lines-table {
    border: 0;
    background: transparent;
  }

  .debit-adjustment-lines .debit-line-row {
    min-height: 0;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    grid-template-rows: auto;
    gap: var(--space-3, 12px);
    padding: var(--space-3, 12px);
    border: 1px solid var(--dn-border);
    border-radius: var(--radius-md, 10px);
  }

  .debit-adjustment-lines .debit-line-row + .debit-line-row {
    margin-top: var(--space-3, 12px);
  }

  .debit-adjustment-lines .debit-mobile-line-label {
    display: block;
    grid-column: 1;
    grid-row: 1;
    color: var(--text-secondary);
    font-size: var(--font-size-caption-md, 11px);
  }

  .debit-adjustment-lines .debit-line-row .debit-description {
    grid-column: 1 / -1;
    grid-row: 2;
    flex-direction: column;
    align-items: stretch;
    gap: var(--space-1, 4px);
    min-height: 0;
    padding: 0;
  }

  .debit-adjustment-lines .debit-description .sr-only,
  .debit-adjustment-lines .debit-line-row > label > span,
  .debit-adjustment-lines .debit-line-total > span {
    display: block;
    position: static;
    width: auto;
    height: auto;
    margin: 0;
    overflow: visible;
    clip: auto;
    color: var(--text-secondary);
    font-size: var(--font-size-body-sm, 13px);
    line-height: 1.4;
    white-space: normal;
  }

  .debit-adjustment-lines .debit-line-row > label {
    min-height: 0;
    padding: 0;
    align-self: stretch;
    justify-content: flex-end;
  }

  .debit-adjustment-lines .debit-line-row .debit-quantity {
    grid-column: 1;
    grid-row: 3;
  }

  .debit-adjustment-lines .debit-line-row .debit-unit-amount {
    grid-column: 2;
    grid-row: 3;
  }

  .debit-adjustment-lines .debit-line-row .debit-remove-line {
    grid-column: 2;
    grid-row: 1;
    width: 32px;
    height: 32px;
    justify-self: end;
    align-self: center;
  }

  .debit-adjustment-lines .debit-remove-icon-desktop {
    display: none;
  }

  .debit-adjustment-lines .debit-remove-icon-mobile {
    display: block;
  }

  .debit-adjustment-lines .debit-line-total {
    display: flex;
    grid-column: 1 / -1;
    grid-row: 4;
    min-height: 0;
    padding: 0;
    gap: var(--space-3, 12px);
    justify-content: space-between;
  }

  .debit-page .debit-adjustment-lines .debit-line-total strong {
    width: auto;
    max-width: 65%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/layouts/DebitNote/debitAdjustmentLines.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,WAAW;AACb;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,2DAA2D;AAC7D;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;;;;EAIE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iDAAiD;EACjD,kDAAkD;AACpD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,0BAA0B;EAC1B,0CAA0C;EAC1C,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,oDAAoD;IACpD,wBAAwB;IACxB,yBAAyB;IACzB,6BAA6B;IAC7B,kCAAkC;IAClC,qCAAqC;EACvC;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,cAAc;IACd,WAAW;IACX,4BAA4B;IAC5B,4CAA4C;EAC9C;;EAEA;IACE,mBAAmB;IACnB,WAAW;IACX,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;IACxB,aAAa;IACb,UAAU;EACZ;;EAEA;;;IAGE,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,4BAA4B;IAC5B,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,UAAU;IACV,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,cAAc;IACd,WAAW;IACX,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,UAAU;IACV,yBAAyB;IACzB,8BAA8B;EAChC;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;AACF","sourcesContent":["/* Fit adjustment fields to the form column, including beside the preview. */\n.debit-editor-form:has(.debit-adjustment-lines) {\n  width: 100%;\n}\n\n.debit-adjustment-lines {\n  container: debit-adjustment-lines / inline-size;\n}\n\n.debit-page .debit-adjustment-lines .debit-lines-table {\n  overflow: visible;\n}\n\n.debit-adjustment-lines .debit-line-head,\n.debit-adjustment-lines .debit-line-row {\n  grid-template-columns: minmax(0, 1fr) 72px 120px 120px 64px;\n}\n\n.debit-adjustment-lines .debit-line-head > span {\n  height: auto;\n  min-height: 32px;\n  text-align: left;\n  overflow-wrap: anywhere;\n}\n\n.debit-adjustment-lines .debit-line-head > span:last-child {\n  padding-inline: 0;\n  white-space: nowrap;\n  overflow-wrap: normal;\n}\n\n.debit-adjustment-lines .debit-line-row,\n.debit-adjustment-lines .debit-line-row > label,\n.debit-adjustment-lines .debit-description,\n.debit-adjustment-lines .debit-line-total {\n  height: auto;\n  min-height: 64px;\n}\n\n.debit-adjustment-lines .debit-line-row:last-child {\n  border-bottom-left-radius: var(--radius-md, 10px);\n  border-bottom-right-radius: var(--radius-md, 10px);\n}\n\n.debit-page .debit-adjustment-lines .debit-line-row input {\n  height: var(--control-height-md, 40px);\n}\n\n.debit-adjustment-lines .debit-description .sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n}\n\n.debit-page .debit-adjustment-lines .debit-line-total strong {\n  display: block;\n  height: auto;\n  min-height: var(--control-height-md, 40px);\n  max-width: 100%;\n  padding-block: 10px;\n  overflow: visible;\n  color: var(--text-primary);\n  font-size: var(--font-size-money-md, 15px);\n  text-align: right;\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n@container debit-adjustment-lines (max-width: 700px) {\n  .debit-adjustment-lines .debit-line-head {\n    display: none;\n  }\n\n  .debit-page .debit-adjustment-lines .debit-lines-table {\n    border: 0;\n    background: transparent;\n  }\n\n  .debit-adjustment-lines .debit-line-row {\n    min-height: 0;\n    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);\n    grid-template-rows: auto;\n    gap: var(--space-3, 12px);\n    padding: var(--space-3, 12px);\n    border: 1px solid var(--dn-border);\n    border-radius: var(--radius-md, 10px);\n  }\n\n  .debit-adjustment-lines .debit-line-row + .debit-line-row {\n    margin-top: var(--space-3, 12px);\n  }\n\n  .debit-adjustment-lines .debit-mobile-line-label {\n    display: block;\n    grid-column: 1;\n    grid-row: 1;\n    color: var(--text-secondary);\n    font-size: var(--font-size-caption-md, 11px);\n  }\n\n  .debit-adjustment-lines .debit-line-row .debit-description {\n    grid-column: 1 / -1;\n    grid-row: 2;\n    flex-direction: column;\n    align-items: stretch;\n    gap: var(--space-1, 4px);\n    min-height: 0;\n    padding: 0;\n  }\n\n  .debit-adjustment-lines .debit-description .sr-only,\n  .debit-adjustment-lines .debit-line-row > label > span,\n  .debit-adjustment-lines .debit-line-total > span {\n    display: block;\n    position: static;\n    width: auto;\n    height: auto;\n    margin: 0;\n    overflow: visible;\n    clip: auto;\n    color: var(--text-secondary);\n    font-size: var(--font-size-body-sm, 13px);\n    line-height: 1.4;\n    white-space: normal;\n  }\n\n  .debit-adjustment-lines .debit-line-row > label {\n    min-height: 0;\n    padding: 0;\n    align-self: stretch;\n    justify-content: flex-end;\n  }\n\n  .debit-adjustment-lines .debit-line-row .debit-quantity {\n    grid-column: 1;\n    grid-row: 3;\n  }\n\n  .debit-adjustment-lines .debit-line-row .debit-unit-amount {\n    grid-column: 2;\n    grid-row: 3;\n  }\n\n  .debit-adjustment-lines .debit-line-row .debit-remove-line {\n    grid-column: 2;\n    grid-row: 1;\n    width: 32px;\n    height: 32px;\n    justify-self: end;\n    align-self: center;\n  }\n\n  .debit-adjustment-lines .debit-remove-icon-desktop {\n    display: none;\n  }\n\n  .debit-adjustment-lines .debit-remove-icon-mobile {\n    display: block;\n  }\n\n  .debit-adjustment-lines .debit-line-total {\n    display: flex;\n    grid-column: 1 / -1;\n    grid-row: 4;\n    min-height: 0;\n    padding: 0;\n    gap: var(--space-3, 12px);\n    justify-content: space-between;\n  }\n\n  .debit-page .debit-adjustment-lines .debit-line-total strong {\n    width: auto;\n    max-width: 65%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
